import { RecordSourceSelectorProxy, OperationType } from 'relay-runtime';

export function guestCheckoutWalletUpdater<T extends OperationType>(
    store: RecordSourceSelectorProxy<T['response']>,
    viewerId: string,
    mutationName: keyof T['response']
): void {
    const payload = store.getRootField(mutationName);
    const payloadUserProxy = payload.getLinkedRecord('user');
    const viewerProxy = store.get(viewerId);
    if (!viewerProxy) {
        throw new Error('Could not get viewer in guestCheckoutWalletUpdater');
    }
    if (!payloadUserProxy) {
        throw new Error('Could not get user in guestCheckoutWalletUpdater');
    }
    const buyerProxy = viewerProxy.getOrCreateLinkedRecord('user', 'User', {
        userId: payloadUserProxy.getValue('serviceId'),
    });
    if (!buyerProxy) {
        return;
    }
    const payloadWalletProxy = payloadUserProxy.getOrCreateLinkedRecord('wallet', 'Wallet');
    const payloadPaymentMethodsProxies =
        payloadWalletProxy.getLinkedRecords('paymentMethods') || [];

    payloadWalletProxy.setLinkedRecords([...payloadPaymentMethodsProxies], 'paymentMethods');
    buyerProxy.copyFieldsFrom(payloadUserProxy);
}
